import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { BreadcrumbsProvider, Loader } from '@intellecteu/common-ui';
import { useStore } from 'data';
import keycloak from '../data/keycloak';
import App from './pages';
import { Toast } from './components/core';

import 'app/styles/global.module.scss';

const container = document.getElementById('root') as HTMLElement;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const Besu = () => {
  const { setAuthorization } = useStore();

  const eventLogger = (event: unknown) => {
    if (event && event === 'onAuthSuccess') {
      setAuthorization(keycloak);
    }
  };

  return (
    <ReactKeycloakProvider
      initOptions={{ onLoad: 'login-required' }}
      LoadingComponent={<Loader.FullPage />}
      authClient={keycloak}
      onEvent={eventLogger}
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <BreadcrumbsProvider>
            <>
              <App />
              <Toast />
            </>
          </BreadcrumbsProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ReactKeycloakProvider>
  );
};

const root = createRoot(container);

root.render(<Besu />);
